class InfiniteScroll {
  constructor(options = {}) {
    this.settings = Object.assign({productGridSelector:'#product-grid',nextPageLinkSelector:'#next-page-link',loadingSpinnerSelector:'#loading-spinner',threshold:400},options);
    this.grid = document.querySelector(this.settings.productGridSelector);
    this.next = document.querySelector(this.settings.nextPageLinkSelector);
    this.spinner = document.querySelector(this.settings.loadingSpinnerSelector);
    this.destroyed = false;
    this.loading = false;
    this.onScroll = this.onScroll.bind(this);
    if (this.grid && this.next) window.addEventListener('scroll',this.onScroll,{passive:true});
  }
  onScroll() {
    if (this.destroyed || this.loading || !this.next || !this.grid.isConnected) return;
    if (this.grid.getBoundingClientRect().bottom <= window.innerHeight + this.settings.threshold) this.loadMoreProducts();
  }
  async loadMoreProducts() {
    if (this.destroyed || this.loading || !this.next) return;
    this.loading = true;
    this.spinner?.classList.remove('hidden');
    this.controller = new AbortController();
    try {
      const url = new URL(this.next.href);
      if (this.grid.dataset.id) url.searchParams.set('section_id',this.grid.dataset.id);
      const response = await fetch(url,{signal:this.controller.signal});
      if (!response.ok) throw new Error('Collection request failed');
      const html = await response.text();
      if (this.destroyed || !this.grid.isConnected) return;
      const doc = new DOMParser().parseFromString(html,'text/html');
      const grid = doc.querySelector(this.settings.productGridSelector);
      if (!grid) throw new Error('Collection products missing');
      grid.querySelectorAll('.scroll-trigger').forEach(item=>item.classList.add('scroll-trigger--cancel'));
      this.grid.insertAdjacentHTML('beforeend',grid.innerHTML);
      const next = doc.querySelector(this.settings.nextPageLinkSelector);
      if (next) this.next.href = next.href;
      else { this.next = null; window.removeEventListener('scroll',this.onScroll); }
    } catch(error) {
      if (error.name !== 'AbortError') console.error('Could not load more products',error);
    } finally {
      this.loading = false;
      if (!this.destroyed) this.spinner?.classList.add('hidden');
    }
  }
  destroy() {
    this.destroyed = true;
    this.controller?.abort();
    window.removeEventListener('scroll',this.onScroll);
    this.spinner?.classList.add('hidden');
  }
}
window.InfiniteScroll = InfiniteScroll;
